<template>
  <div class="animated fadeIn">
    <h1>管理画面予定地</h1>
  </div>
</template>

<script>

export default {
  name: 'dashboard',
  components: {
  },
  data: function () {
    return {
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/manage/Manage.vue